exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "delegations-list{width:100%}delegations-list .create-delegation-container{float:right;margin-top:15px;margin-bottom:15px}delegations-list .right-aligned{float:right}delegations-list .card-container{margin-bottom:5px;margin-top:5px}delegations-list .list-empty{margin-top:40px;text-align:center;font-family:Stag Sans;font-weight:400;font-size:19px;color:#0072c9}delegations-list .list-empty.responsiveMobile{margin-top:120px;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex-direction:column;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;-ms-flex-align:center;-moz-align-items:center;align-items:center;padding-bottom:10px;border-bottom:1px solid #dddfe2}delegations-list .list-empty.responsiveMobile .icon-warning{margin-right:0}delegations-list .list-empty.shown-filter{margin-top:0}delegations-list .list-empty .icon-warning{font-size:77px;margin-right:11px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/delegationsList/delegationsList.scss
// module id = 753
// module chunks = 0